import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import AnimatedPage from "../components/AnimatedPage";
import Header from "../components/Header";
import Footer from "../components/Footer";

function Invite() {
    const [profile, setProfile] = useState(null);
    const [isShow, setShow] = useState(false);
    const [daily, setDaily] = useState(null);
    const [popup, setPopup] = useState(null);
    
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    };

    function formatDate(m) {
        new Date(m);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                setProfile(res.data.data);
            })
            .catch((err) => localStorage.removeItem("user"));
            
        axios.post(`${process.env.REACT_APP_API_URL}/auth/getCustomer`, { code: "" }).then((res) => {
            setDaily(res.data.data);
        });
    }, []);

    const handleCopyClick = (text) => {
        const textToCopy = text;
        const tempInput = document.createElement("input");
        tempInput.value = textToCopy;
        document.body.appendChild(tempInput);
        tempInput.select();
        tempInput.setSelectionRange(0, 99999);
        document.execCommand("copy");
        document.body.removeChild(tempInput);
        swal("Thành công", "Copy mã mời thành công", "success");
    };

    const thongkeAff = (username) => {
        axios
            .post(`${process.env.REACT_APP_API_URL}/auth/thongkeaff`, { username })
            .then((res) => {
                setPopup(res.data.data);
                setShow(true);
            })
            .catch((err) => swal("Chưa có dữ liệu", "Người chơi này chưa tham gia trò chơi nào", "info"));
    };

    const chuyenDoi = () => {
        axios
            .post(`${process.env.REACT_APP_API_URL}/auth/chuyendoiaff`, {})
            .then((res) => {
                swal("Thành công", "Đã chuyển đổi toàn bộ hoa hồng thành số dư tài khoản", "success");
            })
            .catch((err) => swal("Thông báo", err.response?.data?.message !== "" ? err.response.data.message : "Đã có lỗi xảy ra!", "error"));
    };

    return (
        <AnimatedPage>
            <Header profile={profile} />

            <style>{`
                html, body, #root {
                    height: auto !important;
                    min-height: 100vh;
                    overflow-y: auto !important;
                    background-color: #e3e1e2 !important; 
                    margin: 0; padding: 0;
                }
                
                .invite-wrapper {
                    padding-bottom: 100px;
                    background-color: #e3e1e2;
                    min-height: 100vh;
                }

                /* ================================================== */
                /* 1. THÔNG TIN USER (BANNER CHUNG)                   */
                /* ================================================== */
                .center-head {
                    width: 100%;
                    height: 180px;
                    background: url('https://dztwieyphe62d.cloudfront.net/content/images/main/user/banner-center.jpg') center top no-repeat;
                    background-size: cover;
                    padding: 0 20px; 
                    display: flex;
                    align-items: center; 
                    color: #fff;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
                }
                .profile-avatar-wrapper { position: relative; margin-right: 15px; flex-shrink: 0; }
                .profile-avatar { width: 65px; height: 65px; background-color: #fff; border-radius: 50%; display: flex; justify-content: center; align-items: center; }
                .profile-avatar i { font-size: 38px; color: #ffca28; }
                .profile-v1-badge { position: absolute; top: -2px; right: -5px; background-color: #ff9800; color: #fff; border-radius: 50%; width: 20px; height: 20px; display: flex; justify-content: center; align-items: center; font-size: 11px; font-weight: bold; border: 2px solid #222; }
                .profile-info { flex: 1; display: flex; flex-direction: column; justify-content: center; text-align: left; }
                .profile-info h3 { margin: 0 0 2px 0; font-size: 16px; font-weight: bold; color: #fff; }
                .profile-info p.email { margin: 0 0 6px 0; font-size: 13px; color: #ddd; }
                .profile-stats p { margin: 2px 0; font-size: 13px; color: #fff; }
                .profile-stats span { color: #ff9800; font-weight: bold; }

                /* ================================================== */
                /* 2. TIÊU ĐỀ TRANG VÀ NÚT BACK                       */
                /* ================================================== */
                .page-header-box {
                    display: flex;
                    align-items: center;
                    padding: 15px;
                    background: transparent;
                }
                .back-btn {
                    background: #fff;
                    color: #b71c1c;
                    width: 35px;
                    height: 35px;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    margin-right: 15px;
                }
                .back-btn:active { background: #f0f0f0; }
                .page-title-h1 {
                    font-size: 18px;
                    font-weight: bold;
                    color: #333;
                    margin: 0;
                    text-transform: uppercase;
                }

                /* ================================================== */
                /* 3. NỘI DUNG CHÍNH (CÁC THẺ WHITE CARD)             */
                /* ================================================== */
                .invite-content {
                    padding: 0 15px 20px 15px;
                }

                .invite-card {
                    background: #fff;
                    border-radius: 8px;
                    padding: 20px 15px;
                    box-shadow: 0 2px 6px rgba(0,0,0,0.08);
                    margin-bottom: 15px;
                }

                /* Card Mã Mời */
                .code-display {
                    background: #f9f9f9;
                    border: 2px dashed #b71c1c;
                    padding: 15px;
                    border-radius: 8px;
                    text-align: center;
                    margin-top: 15px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 15px;
                }
                .code-display h2 { margin: 0; color: #b71c1c; font-size: 24px; letter-spacing: 2px; }
                .btn-copy { background: #b71c1c; color: #fff; padding: 5px 12px; border-radius: 4px; font-size: 12px; font-weight: bold; }

                .rate-list { margin-top: 10px; font-size: 14px; color: #444; line-height: 1.8; }
                .rate-list b { color: #2e7d32; }

                /* Card Chuyển Đổi */
                .convert-row {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                .convert-info h4 { margin: 0 0 5px 0; font-size: 14px; color: #555; }
                .convert-info h3 { margin: 0; font-size: 24px; color: #4caf50; }
                .btn-convert {
                    background: #b71c1c;
                    color: #fff;
                    border: none;
                    padding: 12px 20px;
                    border-radius: 6px;
                    font-weight: bold;
                    font-size: 14px;
                    cursor: pointer;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
                }

                /* Card Bảng Đại Lý */
                .affiliate-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 13px;
                    text-align: center;
                }
                .affiliate-table th {
                    background: #f0f0f0;
                    padding: 10px 5px;
                    color: #333;
                    font-weight: bold;
                    border-bottom: 2px solid #ddd;
                }
                .affiliate-table td {
                    padding: 12px 5px;
                    border-bottom: 1px solid #eee;
                    color: #555;
                    vertical-align: middle;
                }
                .btn-check-aff {
                    background: #2196f3;
                    color: #fff;
                    border: none;
                    padding: 6px 10px;
                    border-radius: 4px;
                    font-size: 11px;
                    font-weight: bold;
                    cursor: pointer;
                }

                /* Box hướng dẫn / Chú ý */
                .huongdan { 
                    background: #fff; padding: 15px; border-radius: 8px; 
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1); font-size: 13px; line-height: 1.6; color: #444; 
                    margin-bottom: 15px;
                }
                .huongdan .title { font-size: 15px; color: #b71c1c; margin-bottom: 10px; font-weight: bold; text-transform: uppercase;}
                .huongdan ul { padding-left: 20px; margin: 0; }

                /* ================================================== */
                /* 4. MODAL CHI TIẾT HOA HỒNG                         */
                /* ================================================== */
                .custom-modal-overlay {
                    position: fixed; top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0,0,0,0.6);
                    z-index: 9999999;
                    display: flex; align-items: center; justify-content: center;
                }
                .custom-modal-content {
                    background: #fff;
                    width: 90%;
                    max-width: 400px;
                    border-radius: 12px;
                    overflow: hidden;
                    box-shadow: 0 5px 20px rgba(0,0,0,0.3);
                    animation: slideUp 0.3s ease-out;
                    max-height: 80vh;
                    display: flex;
                    flex-direction: column;
                }
                @keyframes slideUp {
                    from { transform: translateY(20px); opacity: 0; }
                    to { transform: translateY(0); opacity: 1; }
                }
                .custom-modal-header {
                    background: #b71c1c;
                    color: #fff;
                    padding: 15px;
                    font-size: 16px;
                    font-weight: bold;
                    text-align: center;
                }
                .custom-modal-body {
                    padding: 15px;
                    overflow-y: auto;
                    background: #f5f5f5;
                }
                .history-item-card {
                    background: #fff;
                    border-radius: 6px;
                    padding: 12px;
                    margin-bottom: 10px;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                    font-size: 13px;
                }
                .history-item-card .row {
                    display: flex; justify-content: space-between; margin-bottom: 5px;
                }
                .custom-modal-footer {
                    padding: 15px;
                    background: #fff;
                    border-top: 1px solid #eee;
                }
                .btn-close-modal {
                    background: #555;
                    color: #fff;
                    border: none;
                    padding: 12px;
                    border-radius: 6px;
                    font-weight: bold;
                    cursor: pointer;
                    width: 100%;
                    font-size: 15px;
                }
            `}</style>

            <div className="invite-wrapper">
                
               

                {/* 2. TIÊU ĐỀ TRANG */}
                <div className="page-header-box">
                   
                    <h1 className="page-title-h1">Mời bạn bè</h1>
                </div>

                {/* 3. NỘI DUNG CHÍNH */}
                <div className="invite-content">

                    {/* HƯỚNG DẪN */}
                    <div className="huongdan">
                        <div className="title">Giới thiệu bạn bè nhận quà liền tay</div>
                        <ul>
                            <li>Nhận thưởng hoa hồng mỗi khi người chơi được bạn giới thiệu tham gia bất kì trò chơi nào.</li>
                            <li>Số tiền hoa hồng dùng để chuyển đổi sang số dư tài khoản.</li>
                            <li>Số tiền hoa hồng tối thiểu để chuyển đổi sang số dư là 10.000</li>
                        </ul>
                    </div>

                    {/* MÃ MỜI VÀ TỈ LỆ HOA HỒNG */}
                    <div className="invite-card">
                        <div style={{ fontWeight: "bold", fontSize: "16px", color: "#333", borderBottom: "1px solid #eee", paddingBottom: "10px" }}>
                            Tỉ lệ hoa hồng
                        </div>
                        <div className="rate-list">
                            <div>Hoa hồng mini game: <b>{profile?.hoahong ? profile?.hoahong : 1}%</b></div>
                            {profile?.hoahonglive > 0 && (
                                <div>Hoa hồng live casino: <b>{profile?.hoahonglive}%</b></div>
                            )}
                            {profile?.hoahongslots > 0 && (
                                <div>Hoa hồng nổ hũ & bắn cá: <b>{profile?.hoahongslots}%</b></div>
                            )}
                        </div>

                        <div className="code-display" onClick={() => handleCopyClick(profile?.code)}>
                            <div>
                                <div style={{ fontSize: "12px", color: "#666", marginBottom: "5px" }}>Mã mời của bạn</div>
                                <h2>{profile?.code}</h2>
                            </div>
                            <div className="btn-copy">COPY</div>
                        </div>
                    </div>

                    {/* CHUYỂN ĐỔI HOA HỒNG */}
                    <div className="invite-card convert-row">
                        <div className="convert-info">
                            <h4>Hoa hồng hiện tại</h4>
                            <h3>{Number(profile?.moneyaff?.toFixed(0))?.toLocaleString("vi-VN") || 0} ₫</h3>
                        </div>
                        <div>
                            <button className="btn-convert" onClick={chuyenDoi}>
                                CHUYỂN ĐỔI
                            </button>
                        </div>
                    </div>

                    {/* BẢNG BÁO CÁO ĐẠI LÝ */}
                    <div className="invite-card" style={{ padding: "15px 5px" }}>
                        <h3 style={{ margin: "0 0 15px 10px", fontSize: "16px", color: "#333" }}>Báo cáo đại lý</h3>
                        
                        {daily && daily.length > 0 ? (
                            <div style={{ overflowX: "auto" }}>
                                <table className="affiliate-table">
                                    <thead>
                                        <tr>
                                            <th>Tài khoản</th>
                                            <th>Cược</th>
                                            <th>Hoa hồng</th>
                                            <th>Nhật ký</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {daily.map((user, index) => {
                                            if (user?.username !== profile?.username) {
                                                return (
                                                    <tr key={index}>
                                                        <td style={{ textAlign: "left", paddingLeft: "10px" }}>
                                                            <b style={{ color: "#1976d2" }}>{user?.username}</b>
                                                            <br />
                                                            <span style={{ fontSize: "11px", color: "#888" }}>ID: {user?.iduser}</span>
                                                        </td>
                                                        <td>{(user?.totalbet + user?.totalbetapi)?.toLocaleString("vi-VN")}</td>
                                                        <td style={{ color: "#4caf50", fontWeight: "bold" }}>
                                                            {Number(user?.moneyforaff?.toFixed(0))?.toLocaleString("vi-VN")}
                                                        </td>
                                                        <td>
                                                            <button className="btn-check-aff" onClick={() => thongkeAff(user?.username)}>
                                                                Kiểm tra
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                            return null;
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div style={{ textAlign: "center", padding: "20px", color: "#888", fontSize: "14px" }}>
                                Chưa có người dùng nào
                            </div>
                        )}
                    </div>

                </div>
            </div>

            {/* 4. MODAL CHI TIẾT NHẬT KÝ */}
            {isShow === true && (
                <div className="custom-modal-overlay" onClick={() => setShow(false)}>
                    <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="custom-modal-header">
                            Lịch sử của {popup && popup[0] ? popup[0].username : ""}
                        </div>
                        
                        <div className="custom-modal-body">
                            {popup && popup.length > 0 ? (
                                popup.map((item, index) => (
                                    <div className="history-item-card" key={index}>
                                        <div className="row">
                                            <b style={{ color: "#333", fontSize: "14px" }}>
                                                {item.sanh === "3 phút" ? "Keno 3p" : item.sanh === "5 phút" ? "Keno 5p" : item.sanh === "1 phút" ? "Keno 1p" : item.sanh}
                                            </b>
                                            <span style={{ color: "#888", fontSize: "12px" }}>
                                                {formatDate(new Date(item.createdAt))}
                                            </span>
                                        </div>
                                        <div className="row">
                                            <span>Tiền cược:</span>
                                            <b style={{ color: "#b71c1c" }}>{Number(item.money).toLocaleString("vi-VN")} ₫</b>
                                        </div>
                                        <div className="row">
                                            <span>Hoa hồng:</span>
                                            <b style={{ color: "#4caf50" }}>+{Number(item.hoahong).toLocaleString("vi-VN")} ₫</b>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div style={{ textAlign: "center", color: "#888", padding: "20px 0" }}>
                                    Không có dữ liệu
                                </div>
                            )}
                        </div>

                        <div className="custom-modal-footer">
                            <button className="btn-close-modal" onClick={() => setShow(false)}>
                                ĐÓNG
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </AnimatedPage>
    );
}

export default Invite;